module.exports = __webpack_public_path__ + "media/images/steps/face_shield_step3-2963c76960327beb229e1d5e12660fd8.svg";